export const GET_ALL_PAGE_SERVICES = "GET_ALL_PAGE_SERVICES";
export const GET_ALL_PAGE_SERVICES_SUCCESS = "GET_ALL_PAGE_SERVICES_SUCCESS";
export const GET_ALL_PAGE_SERVICES_FAILURE = "GET_ALL_PAGE_SERVICES_FAILURE";

export const GET_SERVICE = "GET_SERVICE";
export const GET_SERVICE_SUCCESS = "GET_SERVICE_SUCCESS";
export const GET_SERVICE_FAILURE = "GET_SERVICE_FAILURE";

export const EDIT_SERVICE = "EDIT_SERVICE";
export const EDIT_SERVICE_SUCCESS = "EDIT_SERVICE_SUCCESS";
export const EDIT_SERVICE_FAILURE = "EDIT_SERVICE_FAILURE";

export const ADD_SERVICE = "ADD_SERVICE";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAILURE = "ADD_SERVICE_FAILURE";

export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAILURE = "DELETE_SERVICE_FAILURE";
